import React from 'react'

function Skills() {
    return (
        <div className='container my-5'>
            <div className='Skills bg-dark rounded text-white p-3 text-center my-4'>
                <div className='h4 '>
                    <p className='text-info'>مهارت های تخصصی</p>
                </div>
                <div className='h5'>
                    Html Css, Bootstrap 5, Responsive Design, Java Script, Jquery, ES6+, React Js, React Query, Next js, Material Ui, C++, C#(unity engine), Photoshop
                </div>
            </div>
            <div className='Skills bg-dark rounded text-white p-3 text-center my-4'>
                <div className='h4 '>
                    <p className='text-warning'>مهارت های در حد متوسط</p>
                </div>
                <div className='h5'>
                    Php, MySql, linux & kali Linux, Adobe Ai, Adobe Xd, Adobe Pr, Onsen Ui, Type Script
                </div>
            </div>
            <div className='Skills bg-dark rounded text-white p-3 text-center my-4'>
                <div className='h4 text-danger'>
                    <p >مهارت های در حد سینتکس</p>
                </div>
                <div className='h5'>
                    Python
                </div>
            </div>
            <div className='Skills bg-dark rounded text-white p-3 text-center my-4'>
                <div className='h4 text-success'>
                    <p>مهارت های در حال یادگیری</p>
                </div>
                <div className='h5'>
                    React Native, Redux, Sass
                </div>
            </div>
        </div>
    )
}

export default Skills
